import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.parse-float";
import "core-js/modules/web.dom-collections.for-each";
import _defineProperty from "/Users/suifeng/Desktop/projects/2026/QianKunLong/QklAdmin/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import dayjs from 'dayjs';
import setting from '@/setting';
import { orderList, userList } from '@/api/apis';
export default {
  name: 'DashboardIndex',
  data: function data() {
    return {
      title: setting.projectName,
      today: dayjs().format('YYYY年MM月DD日 dddd'),
      activeTab: 'week',
      chartTabs: [{
        key: 'week',
        label: '本周'
      }, {
        key: 'month',
        label: '本月'
      }, {
        key: 'year',
        label: '全年'
      }],
      kpiData: [{
        title: '今日订单',
        value: '-',
        trend: 0,
        icon: 'fa fa-shopping-cart',
        bg: 'linear-gradient(135deg, #409EFF, #66B1FF)',
        chartData: {
          columns: ['日期', '值'],
          rows: []
        },
        chartSettings: {
          area: true,
          label: false,
          legend: false,
          xAxis: false,
          yAxis: false
        }
      }, {
        title: '今日新增用户',
        value: '-',
        trend: 0,
        icon: 'fa fa-users',
        bg: 'linear-gradient(135deg, #67C23A, #85CE61)',
        chartData: {
          columns: ['日期', '值'],
          rows: []
        },
        chartSettings: {
          area: true,
          label: false,
          legend: false,
          xAxis: false,
          yAxis: false
        }
      }, {
        title: '今日总营收',
        value: '-',
        trend: 0,
        icon: 'fa fa-cny',
        bg: 'linear-gradient(135deg, #E6A23C, #EBB563)',
        chartData: {
          columns: ['日期', '值'],
          rows: []
        },
        chartSettings: {
          area: true,
          label: false,
          legend: false,
          xAxis: false,
          yAxis: false
        }
      }],
      sparkExtend: {
        color: ['#409EFF'],
        grid: {
          top: 5,
          bottom: 5,
          left: 0,
          right: 0
        },
        xAxis: {
          show: false,
          boundaryGap: false
        },
        yAxis: {
          show: false,
          scale: true
        },
        series: {
          showSymbol: false,
          smooth: true,
          areaStyle: {
            opacity: 0.15
          }
        }
      },
      revenueData: {
        columns: ['日期', '营收', '订单'],
        rows: [{
          日期: '周一',
          营收: 12000,
          订单: 120
        }, {
          日期: '周二',
          营收: 18000,
          订单: 150
        }, {
          日期: '周三',
          营收: 15000,
          订单: 130
        }, {
          日期: '周四',
          营收: 22000,
          订单: 180
        }, {
          日期: '周五',
          营收: 28000,
          订单: 220
        }, {
          日期: '周六',
          营收: 35000,
          订单: 280
        }, {
          日期: '周日',
          营收: 30000,
          订单: 250
        }]
      },
      revenueExtend: {
        color: ['#409EFF', '#67C23A'],
        legend: {
          textStyle: {
            color: '#909399'
          }
        },
        grid: {
          top: 40,
          bottom: 30,
          left: 50,
          right: 20
        },
        xAxis: {
          axisLine: {
            lineStyle: {
              color: '#DCDFE6'
            }
          },
          axisLabel: {
            color: '#909399'
          }
        },
        yAxis: {
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#909399'
          },
          splitLine: {
            lineStyle: {
              color: '#EBEEF5'
            }
          }
        },
        series: {
          smooth: true,
          showSymbol: false,
          areaStyle: {
            opacity: 0.1
          }
        }
      },
      userData: {
        columns: ['类型', '数量'],
        rows: [{
          类型: '普通用户',
          数量: 5200
        }, {
          类型: 'VIP用户',
          数量: 2100
        }, {
          类型: '代理商',
          数量: 850
        }, {
          类型: '管理员',
          数量: 302
        }]
      },
      pieExtend: {
        color: ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C'],
        legend: {
          textStyle: {
            color: '#909399'
          }
        },
        series: {
          radius: ['45%', '70%'],
          label: {
            color: '#606266'
          },
          labelLine: {
            lineStyle: {
              color: '#DCDFE6'
            }
          }
        }
      },
      quickActions: [{
        title: '会员管理',
        desc: '管理平台会员信息',
        icon: 'fa fa-users',
        route: '/member/memberManage'
      }, {
        title: '订单管理',
        desc: '查看和处理订单',
        icon: 'fa fa-list-alt',
        route: '/order/orderManage'
      }, {
        title: '店铺管理',
        desc: '店铺申请审核管理',
        icon: 'fa fa-shopping-bag',
        route: '/store/storeManager'
      }, {
        title: '代理区域',
        desc: '管理代理区域设置',
        icon: 'fa fa-globe',
        route: '/region/regionAgent'
      }, {
        title: '月结算发放',
        desc: '月度奖励手动发放',
        icon: 'fa fa-money',
        route: '/finance/monthSend'
      }, {
        title: '结算配置',
        desc: '结算参数与奖金配置',
        icon: 'fa fa-cogs',
        route: '/config/balanceConfig'
      }, {
        title: '会员档案管理',
        desc: '会员档案信息管理',
        icon: 'fa fa-id-card-o',
        route: '/member/memberInfoApply'
      }, {
        title: '奖金日志',
        desc: '查看奖金发放记录',
        icon: 'fa fa-usd',
        route: '/finance/bonusLog'
      }, {
        title: '前端日志',
        desc: '系统操作日志',
        icon: 'fa fa-file-text-o',
        route: '/log'
      }]
    };
  },
  mounted: function mounted() {
    this.loadKpiData();
  },
  methods: {
    handleQuickAction: function handleQuickAction(action) {
      if (action.route) {
        this.$router.push(action.route).catch(function () {});
      }
    },
    loadKpiData: function loadKpiData() {
      var _this = this;

      var todayRange = this.$g.fun.getDateRange(new Date(), 0, true); // 今日订单 + 今日总营收

      orderList({
        page: 1,
        limit: 1000,
        where: {
          add_time: todayRange
        }
      }).then(function (res) {
        var count = res.count || 0;

        _this.$set(_this.kpiData, 0, _objectSpread({}, _this.kpiData[0], {
          value: count.toLocaleString()
        }));

        var totalRevenue = 0;

        if (res.rows) {
          for (var i in res.rows) {
            totalRevenue += parseFloat(res.rows[i].total_price || 0);
          }
        }

        _this.$set(_this.kpiData, 2, _objectSpread({}, _this.kpiData[2], {
          value: '¥' + totalRevenue.toFixed(2)
        }));
      }).catch(function () {}); // 今日新增用户

      userList({
        page: 1,
        limit: 1,
        where: {
          add_time: todayRange
        }
      }).then(function (res) {
        var count = res.count || 0;

        _this.$set(_this.kpiData, 1, _objectSpread({}, _this.kpiData[1], {
          value: count.toLocaleString()
        }));
      }).catch(function () {});
    }
  }
};